export function hasFlag(flag: number): (value: number) => boolean {
    return (value: number): boolean => {
        return (value & flag) === flag;
    };
}
